<template>
  <van-popup get-container="#app" class="pop-draw" v-model="popShow" :close-on-click-overlay="false">
    <!-- 抽到祝福语 -->
    <div class="draw-container" v-if="blessingUri">
      <img style="width:100%" :src="getImgUrl()" />
    </div>
    <!-- 抽中奖品 -->
    <div class="gift-container" v-if="!blessingUri">
      <img style="width:100%;position:absolute;opacity: 0.5;pointer-events: none;" src="../../../assets/images/new-year/gift-bg.png" />
      <div class="gift-item">
        <img class="item-img" :class="{'vip-img': attendInfo.prizeType == '02'}" :src="getGiftUrl()" />
        <div class="point-value" v-if="attendInfo.pointValue">恭喜您获得{{ attendInfo.pointValue }}易加积分</div>
        <div class="point-value" v-else>恭喜您获得{{attendInfo.itemName}}</div>
      </div>
    </div>
    <div v-if="totalCount > 0 && !blessingUri" class="draw-again" @click="drawAgain()">再抽一次</div>
    <div class="pop-close" @click="closePop()"></div>
  </van-popup>
</template>
<script>
export default {
  props: ['totalCount', 'blessingUri', 'attendInfo'],
  data () {
    return {
      popShow: false
    }
  },
  methods: {
    getImgUrl () {
      console.log(this.blessingUri)
      return process.env.VUE_APP_FILE_SERVER + '/static' + this.blessingUri
    },
    getGiftUrl () {
      const itemCode = this.attendInfo.itemCode
      // 积分
      if (this.attendInfo.prizeType === '01') {
        return require('../../../assets/images/new-year/point.png')
      }
      // vip 卡
      if (this.attendInfo.prizeType === '02') {
        return require('../../../assets/images/new-year/vip.png')
      }
      // 实物礼品
      if (this.attendInfo.prizeType === '03') {
        if (itemCode === 'G170207') {
          // 果汁杯
          return require('../../../assets/images/new-year/cup.png')
        }
        if (itemCode === 'G170120') {
          // U 盘
          return require('../../../assets/images/new-year/bosch-u.png')
        }
        if (itemCode === 'G170462') {
          // 洗手液
          return require('../../../assets/images/new-year/wash.png')
        }
      }
    },
    drawAgain () {
      console.log('again')
      this.popShow = false
      this.$parent.getBestDraw()
    },
    popAppear () {
      this.popShow = true
    },
    closePop () {
      this.popShow = false
      this.$emit('closePop')
    }
  }
}
</script>
<style lang="less" scoped>
@font-face{
  font-family: 'Huawenlishu';
  src : url('../../../assets/fonts/huawenlishu.ttf');
}
.pop-draw {
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.1);
  overflow: hidden;
  pointer-events: none;
}
.draw-container {
  width: 252px;
  height: 365px;
  margin: 30% auto 0;
  background-color: rgba(0,0,0,.1);
  animation: draw 1s linear 1;
  transform-origin: center;
}
@keyframes draw{
    0%{
      transform: scale(0.1);
      transform: rotateY(0deg);
    }
    25% {
      transform: scale(.3);
      transform: rotateY(-180deg);
    }
    50% {
      transform: scale(.5);
      transform: rotateY(-360deg);
    }
    75% {
      transform: scale(.8);
      transform: rotateY(-180deg);
    }
    100%{
      transform: scale(1);
      transform: rotateY(-360deg);
    }
}
.gift-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 375px;
  height: 375px;
  margin-top: 20%;
  border-radius: 50%;
  animation: gift 30s linear infinite;
  pointer-events: none;
  .gift-item {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    animation: giftItem 30s linear infinite;
    .item-img {
      width: 120px;
    }
    .vip-img {
      width: 180px;
      box-shadow: 0px 0px 10px #dce321;
    }
    .point-value {
      margin-top: 20px;
      color: #ffffff;
      font-size: 16px;
      text-align: center;
    }
  }
}
@keyframes gift{
    0%{
      transform: rotateZ(0deg);
    }
    50% {
      transform: rotateZ(180deg);
    }
    100%{
      transform: rotateZ(360deg);
    }
}
@keyframes giftItem{
    0%{
      transform: rotateZ(-0deg);
    }
    50% {
      transform: rotateZ(-180deg);
    }
    100%{
      transform: rotateZ(-360deg);
    }
}
.draw-again {
  width: 169px;
  height: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: -60px auto 0px;
  padding: 5px 20px 25px 10px;
  font-size: 22px;
  color: #7b4b07;
  font-family: "华文隶书", "Huawenlishu", "PingFang SC", "Heiti SC", "Droidsansfallback", "Helvetica", "sans-serif";
  background-image: url('../../../assets/images/new-year/draw.png');
  background-size: 100%;
  box-sizing: border-box;
  pointer-events: auto;
}
.pop-close {
  width: 28px;
  height: 28px;
  margin: 20px auto 0;
  background-image: url('../../../assets/images/new-year/close.png');
  background-size: 100%;
  background-repeat: no-repeat;
  pointer-events: auto;
}
</style>
